import React from 'react'
import { addToConsignmentsBag, changeQuantityConsignmentsBag, removeToConsignmentsBag } from '../../../../../actions/inventoryActions'
import { PaymentSummary } from './PaymentSummary'
import ProductItem from './ProductItem'

const CartConsignmet = ({ bag }) => {
  return (
    <div className='shoping-bag-container'>
      <div className='list-products-bag scroll-menu'>
        {bag.map(item => (
          <ProductItem item={item}
            changeAction={changeQuantityConsignmentsBag}
            removeAction={removeToConsignmentsBag}
          />
        ))}
      </div>
      <PaymentSummary
        bag={bag}
      />

    </div>
  )
}

export default CartConsignmet